export default __webpack_public_path__ + "static/media/egg-step2.0546e6fb.jpg";